import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import QuizDetails from './QuizDetails';
import QuizSuccess from './QuizSuccess';

const Quiz = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/(quiz|quiz/start)"
                            name="QuizDetails"
                            exact
                            component={QuizDetails}
                        />
                        <Route
                            path="/quiz/success"
                            name="QuizSuccess"
                            exact
                            component={QuizSuccess}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Quiz;
